<template>
  <action-dispatcher action="banners/get">
    <div class="slider-home-component position-relative">
      <carousel
        :per-page="1"
        :mouse-drag="true"
        :loop="true"
        :autoplay="true"
        :autoplayTimeout="5000"
        :autoplayHoverPause="false"
        paginationPosition="bottom-overlay"
        paginationActiveColor="#2db563"
        paginationColor="#8B8B8B"
      >
        <slide v-for="banner in banners" :key="banner.id">
          <div class="d-flex justify-content-center w-100">
            <div
              class="img w-100"
              :style="`background-image: url(${banner.image})`"
            >
              <div v-if="banner.course" class="container h-100">
                <div class="row h-100">
                  <div class="col-lg-5 pb-5">
                    <div
                      class="d-flex flex-column justify-content-lg-center justify-content-end pb-5 mb-lg-0 pb-lg-0 h-100"
                    >
                      <h1 class="text-uppercase">
                        {{ banner.title_course }}
                      </h1>
                      <p class="text-green">
                        {{ banner.category_course }}
                      </p>
                      <p>
                        {{ text_formated(banner) }}
                      </p>
                      <div class="row">
                        <div class="col-lg-6">
                          <router-link
                            :to="{
                              name: 'course',
                              params: {
                                id: banner.course,
                                slug: banner.slug_course
                              }
                            }"
                            class="btn btn-success w-100 d-flex align-items-center justify-content-center"
                          >
                            COMEÇAR
                          </router-link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </slide>
      </carousel>
    </div>
  </action-dispatcher>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";
import { mapState } from "vuex";

export default {
  components: {
    Carousel,
    Slide
  },
  methods: {
    text_formated(banner) {
      return banner.description_course.slice(0, 190) + "...";
    }
  },
  computed: {
    ...mapState("banners", ["banners"])
  }
};
</script>

<style scoped lang="scss">
.slider-home-component {
  h1 {
    @media screen and (max-width: 768px) {
      font-size: 32px;
    }
  }

  .text-green {
    color: #2db563;
  }

  a {
    font-size: 24px;
    @media screen and (max-width: 768px) {
      font-size: 16px;
    }
  }

  .img {
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
    height: 80vh !important;

    @media screen and (min-width: 992px) {
      height: 87vh !important;
    }
  }
}

::v-deep .VueCarousel-dot {
  height: 8px !important;
  width: 8px !important;
  margin-bottom: 50px !important;
}
::v-deep .VueCarousel-dot--active {
  width: 30px !important;
  height: 8px !important;
  border-radius: 40px !important;
}
</style>
